export default "__VITE_ASSET__C_1Vdd0V__"